import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Gift = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ ...style(props.size), ...props.style }}
  >
    <defs>
      <path
        d="M15.75,4.66666662 C17.3771516,4.66666662 18.6666667,6.09764312 18.6666667,7.82999997 L18.6609999,7.99966662 L19.3333334,7.99999998 C19.6680514,7.99999998 19.9451553,8.24667505 19.9927716,8.56815153 L19.9999999,8.66666665 L19.9999999,12 C19.9999999,12.3681898 19.7015232,12.6666667 19.3333334,12.6666667 L19.3333334,12.6666667 L19.3333334,17.3333333 C19.3333334,18.3987307 18.5009869,19.2691271 17.4508772,19.3299393 L17.3333334,19.3333333 L6.66666662,19.3333333 C5.60126929,19.3333333 4.73087293,18.5009869 4.67006069,17.4508772 L4.66666662,17.3333333 L4.66666662,12.6666667 C4.29847679,12.6666667 3.99999995,12.3681898 3.99999995,12 L3.99999995,12 L3.99999995,8.66666665 C3.99999995,8.29847681 4.29847679,7.99999998 4.66666662,7.99999998 L4.66666662,7.99999998 L5.33747169,8.00017076 C5.33471694,7.94366269 5.33333329,7.88692236 5.33333329,7.82999997 C5.33333329,6.09764312 6.62284844,4.66666662 8.24999998,4.66666662 C9.48361486,4.66666662 10.5581163,5.40033985 11.4922265,6.58485094 C11.6750203,6.81664507 11.8449947,7.05707803 12.0019839,7.30104608 C12.1550053,7.05707803 12.3249797,6.81664507 12.5077735,6.58485094 C13.4418837,5.40033985 14.5163851,4.66666662 15.75,4.66666662 Z M11.3329999,12.6666666 L5.99999995,12.6666666 L5.99999996,17.3333333 C5.99999996,17.6754904 6.25711263,17.9570429 6.58886619,17.995519 L6.66666662,18 L11.3329999,17.9996666 L11.3329999,12.6666666 Z M17.9999999,12.6666666 L12.6659999,12.6666666 L12.6659999,17.9996666 L17.3333334,18 C17.6754904,18 17.9570429,17.7428874 17.995519,17.4111338 L18,17.3333333 L17.9999999,12.6666666 Z M18.6666667,9.33333332 L5.33333329,9.33333332 L5.33333329,11.3333333 L18.6666667,11.3333333 L18.6666667,9.33333332 Z M8.24999998,5.99999996 C7.39196325,5.99999996 6.66666663,6.80486248 6.66666663,7.82999997 C6.66666663,7.88707532 6.66890822,7.94370317 6.67334592,7.99975208 L10.8661498,8.00005385 C10.7352868,7.79811082 10.5946896,7.59995146 10.4452735,7.41048233 C9.73875871,6.51457674 8.98513511,5.99999996 8.24999998,5.99999996 Z M15.75,5.99999996 C15.0148649,5.99999996 14.2612413,6.51457674 13.5547265,7.41048233 C13.4053104,7.59995146 13.2647132,7.79811082 13.1338502,8.00005385 L17.3266541,7.99975208 C17.3310918,7.94370317 17.3333334,7.88707532 17.3333334,7.82999997 C17.3333334,6.80486248 16.6080368,5.99999996 15.75,5.99999996 Z"
        id="path-1-gift"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/shopping/gift/line">
        <mask id="mask-2-gift" fill="white">
          <use xlinkHref="#path-1-gift"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#path-1-gift"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-gift)"
          fill={props.color || theme.palette.grey600}
          fillOpacity="0.6"
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
